/** THIS FILE IS AUTOMATICALLY GENERATED FROM : https://preprod-api.direct-dm.co.il/swagger/v1/swagger.json **/

import axios from "../axios"
import * as BMW from "./BMWInterfaces"

export const postAccountVerifyUser = (data: BMW.VerifyUserRequest) =>
  axios.post<BMW.VerifyUserResponseResponseWrapper>(
    `/api/account/verifyUser`,
    data,
    { headers: {} },
  )

export const postAccountGenerateVerificationCode = (
  data: BMW.GenerateVerificationCodeRequest,
) =>
  axios.post<BMW.GenerateVerificationCodeResponseResponseWrapper>(
    `/api/account/generateVerificationCode`,
    data,
    { headers: {} },
  )

export const postAccountRegister = (data: BMW.ShortRegistrationRequest) =>
  axios.post<BMW.UserRegistrationResponseResponseWrapper>(
    `/api/account/register`,
    data,
    { headers: {} },
  )

export const getAccountGetUserInfo = () =>
  axios.get<BMW.UserInfoResponseResponseWrapper>(`/api/account/getUserInfo`, {
    headers: {},
  })

export const postAccountLogout = () =>
  axios.post<BMW.BooleanResponseWrapper>(`/api/account/logout`, { headers: {} })

export const postAnalyticsTrackClick = (data: BMW.CarModelClickRequest) =>
  axios.post<any>(`/api/analytics/track-click`, data, { headers: {} })

export const getAnalyticsTopClicked = (top: number /* int32 */) =>
  axios.get<BMW.TopClickedCarModelsResponseResponseWrapper>(
    `/api/analytics/top-clicked`,
    { params: { top }, headers: {} },
  )

export const getAnalyticsTopClickedDateRange = (
  startDate: string /* date-time */,
  endDate: string /* date-time */,
  top: number /* int32 */,
) =>
  axios.get<BMW.TopClickedCarModelsResponseResponseWrapper>(
    `/api/analytics/top-clicked-date-range`,
    { params: { startDate, endDate, top }, headers: {} },
  )

export const getAnalyticsCarModelStatsCarModelId = (carModelId: string) =>
  axios.get<BMW.CarModelClickStatsDtoResponseWrapper>(
    `/api/analytics/car-model-stats/${carModelId}`,
    { headers: {} },
  )

export const getAppMetaDataGetAllBrands = () =>
  axios.get<BMW.BrandDtoListResponseWrapper>(`/api/appMetaData/getAllBrands`, {
    headers: {},
  })

export const getAppMetaDataGetAllShowRoom = () =>
  axios.get<BMW.ShowRoomDtoListResponseWrapper>(
    `/api/appMetaData/getAllShowRoom`,
    { headers: {} },
  )

export const getAppMetaDataGetFaq = () =>
  axios.get<BMW.FaqDetailsDtoResponseWrapper>(`/api/appMetaData/getFaq`, {
    headers: {},
  })

export const getAppMetaDataGetAllAdvantages = () =>
  axios.get<BMW.AdvantageDtoResponseWrapper>(
    `/api/appMetaData/getAllAdvantages`,
    { headers: {} },
  )

export const getAppMetaDataGetMainBanner = () =>
  axios.get<BMW.MainBannerDtoResponseWrapper>(
    `/api/appMetaData/getMainBanner`,
    { headers: {} },
  )

export const getAppMetaDataGetHeroBanners = () =>
  axios.get<BMW.HeroBannerDtoListResponseWrapper>(
    `/api/appMetaData/getHeroBanners`,
    { headers: {} },
  )

export const getAppMetaDataGetNewsletter = () =>
  axios.get<BMW.NewsletterDtoResponseWrapper>(
    `/api/appMetaData/getNewsletter`,
    { headers: {} },
  )

export const getAppMetaDataGetEngineTypes = () =>
  axios.get<BMW.ViewDataModelListResponseWrapper>(
    `/api/appMetaData/getEngineTypes`,
    { headers: {} },
  )

export const getBlogGetAll = () =>
  axios.get<BMW.BlogsEntryDtoListResponseWrapper>(`/api/blog/getAll`, {
    headers: {},
  })

export const getBlogGetById = (id: number /* int32 */) =>
  axios.get<BMW.BlogsEntryDtoResponseWrapper>(`/api/blog/getById`, {
    params: { id },
    headers: {},
  })

export const getBlogGetAllThin = () =>
  axios.get<BMW.BlogEntryThinDtoListResponseWrapper>(`/api/blog/getAllThin`, {
    headers: {},
  })

export const getBlogLobby = () =>
  axios.get<BMW.BlogLobbyDtoResponseWrapper>(`/api/blog/lobby`, { headers: {} })

export const postBlogGetThinLobbyEntry = (data: BMW.BlogEntryThinRequest) =>
  axios.post<BMW.BlogEntryThinDtoPaginatedListResponseWrapper>(
    `/api/blog/getThinLobbyEntry`,
    data,
    { headers: {} },
  )

export const getBlogGetCategories = () =>
  axios.get<BMW.BlogCategoryDtoListResponseWrapper>(`/api/blog/getCategories`, {
    headers: {},
  })

export const getCarmodelGetAll = () =>
  axios.get<BMW.CarModelDtoListResponseWrapper>(`/api/carmodel/getAll`, {
    headers: {},
  })

export const getCarmodelGetSpecialStrips = () =>
  axios.get<BMW.CarModelSpecialStripDtoListResponseWrapper>(
    `/api/carmodel/getSpecialStrips`,
    { headers: {} },
  )

export const getCarmodelGetById = (id: number /* int32 */) =>
  axios.get<BMW.CarModelDtoResponseWrapper>(`/api/carmodel/getById`, {
    params: { id },
    headers: {},
  })

export const getCarmodelGetFutureModelsByBrand = (
  brandId: number /* int32 */,
) =>
  axios.get<BMW.FutureCarModelDtoListResponseWrapper>(
    `/api/carmodel/getFutureModelsByBrand`,
    { params: { brandId }, headers: {} },
  )

export const postCarmodelInrestedCars = (data: BMW.IntrestedCarRequest) =>
  axios.post<BMW.CarModelDtoListResponseWrapper>(
    `/api/carmodel/InrestedCars`,
    data,
    { headers: {} },
  )

export const getClearcacheClearAll = () =>
  axios.get<BMW.BooleanResponseWrapper>(`/api/clearcache/clearAll`, {
    headers: {},
  })

export const postContactContact = (data: BMW.Contact) =>
  axios.post<BMW.BooleanResponseWrapper>(`/api/contact/Contact`, data, {
    headers: {},
  })

export const postContactNewsLetter = (data: BMW.NewsLetterRequest) =>
  axios.post<BMW.BooleanResponseWrapper>(`/api/contact/NewsLetter`, data, {
    headers: {},
  })

export const getExampleRedisTest = () =>
  axios.get<BMW.MessageReponseListResponseWrapper>(`/api/example/redisTest`, {
    headers: {},
  })

export const getSettingsAll = () =>
  axios.get<BMW.GeneralSettingResponseListResponseWrapper>(
    `/api/settings/all`,
    { headers: {} },
  )

export const getHardSaleDropActiveDrop = () =>
  axios.get<BMW.HardSaleDropDtoResponseWrapper>(
    `/api/hardSaleDrop/activeDrop`,
    { headers: {} },
  )

export const getHomepageHomePage = () =>
  axios.get<BMW.HomePageDtoResponseWrapper>(`/api/homepage/HomePage`, {
    headers: {},
  })

export const getMessagesMarkAsRead = (messageId: number /* int32 */) =>
  axios.get<BMW.BooleanResponseWrapper>(`/api/messages/markAsRead`, {
    params: { messageId },
    headers: {},
  })

export const getMessagesMarkAsReadByNotification = (
  notificationId: number /* int32 */,
) =>
  axios.get<BMW.BooleanResponseWrapper>(
    `/api/messages/markAsReadByNotification`,
    { params: { notificationId }, headers: {} },
  )

export const postMessagesGet = (FilterType: string) =>
  axios.post<BMW.MessageReponseListResponseWrapper>(`/api/messages/get`, {
    params: { FilterType },
    headers: {},
  })

export const getEcommOrdersId = (id: string) =>
  axios.get<BMW.OrderStatusResponseResponseWrapper>(`/api/ecomm/orders/${id}`, {
    headers: {},
  })

export const postEcommOrdersCreate = (data: BMW.CreateOrderRequest) =>
  axios.post<BMW.CreateOrderResponseResponseWrapper>(
    `/api/ecomm/orders/Create`,
    data,
    { headers: {} },
  )

export const postEcommOrdersComplete = (data: BMW.CompletePaymentRequest) =>
  axios.post<BMW.CompletePaymentResponseResponseWrapper>(
    `/api/ecomm/orders/complete`,
    data,
    { headers: {} },
  )

export const putEcommOrdersUpdate = (data: BMW.EditOrderRequest) =>
  axios.put<BMW.CreateOrderResponseResponseWrapper>(
    `/api/ecomm/orders/Update`,
    data,
    { headers: {} },
  )

export const postEcommPaymentRedirectTransaction = (
  data: BMW.PaymentRedirectRequest,
) =>
  axios.post<BMW.CreditGuardRedirectTransactionDtoResponseWrapper>(
    `/api/ecomm/payment/redirectTransaction`,
    data,
    { headers: {} },
  )

export const postSalesReport = (data: BMW.SalesReportRequest) =>
  axios.post<BMW.SaleDtoPaginatedListResponseWrapper>(
    `/api/sales/report`,
    data,
    { headers: {} },
  )

export const postSalesReportExport = (data: BMW.SalesReportRequest) =>
  axios.post<any>(`/api/sales/report/export`, data, { headers: {} })

export const getSearchGetSearchHeroBanners = () =>
  axios.get<BMW.SearchHeroBannerDtoListResponseWrapper>(
    `/api/search/getSearchHeroBanners`,
    { headers: {} },
  )

export const getSearchGetAllBrandPrices = () =>
  axios.get<BMW.BrandsPriceDtoResponseWrapper>(
    `/api/search/getAllBrandPrices`,
    { headers: {} },
  )

export const getSearchGetAllBrandsBanners = () =>
  axios.get<BMW.BrandBannerDtoListResponseWrapper>(
    `/api/search/getAllBrandsBanners`,
    { headers: {} },
  )

export const getSearchGetBrandBannerById = (brandId: number /* int32 */) =>
  axios.get<BMW.BrandBannerDtoResponseWrapper>(
    `/api/search/getBrandBannerById`,
    { params: { brandId }, headers: {} },
  )

export const getSearchGetSearchPageContent = () =>
  axios.get<BMW.SearchPageContentDtoResponseWrapper>(
    `/api/search/getSearchPageContent`,
    { headers: {} },
  )

export const postSearchSearchCars = (data: BMW.SearchRequest) =>
  axios.post<BMW.SearchResponseResponseWrapper>(
    `/api/search/searchCars`,
    data,
    { headers: {} },
  )

export const postSearchGetPriceRangeByBrands = (data: number /* int32 */[]) =>
  axios.post<BMW.PriceRangeResponseResponseWrapper>(
    `/api/search/GetPriceRangeByBrands`,
    data,
    { headers: {} },
  )

export const getSeoKey = (key: string) =>
  axios.get<BMW.SeoMetaDataDtoResponseWrapper>(`/api/seo/${key}`, {
    headers: {},
  })
